import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreMaterialModule } from '@nttp/core-material';
import { CoreUiModule } from '@nttp/core-ui';
import { SendPaymentModalComponent } from '@pg-app/client/client-dashboard/components/send-payment-modal/send-payment-modal.component';
import { PipeModule } from '@nttp/pipes/pipe.module';
import { PinTwillioAuthyModule } from '@pg-app/common/pin-twillio-authy/pin-twillio-authy.module';
import { PaymentMandateComponent } from '@pg-app/client/client-dashboard/components/send-payment-modal/containers/payment-mandate/payment-mandate.component';
import { PaymentInfomationComponent } from '@pg-app/client/client-dashboard/components/send-payment-modal/containers/payment-infomation/payment-infomation.component';
import { BalanceTradeAvailableComponent } from '@pg-app/client/client-dashboard/components/send-payment-modal/containers/balance-trade-available/balance-trade-available.component';
import { DrawdownSummaryComponent } from '@pg-app/client/client-dashboard/components/send-payment-modal/containers/drawdown-summary/drawdown-summary.component';
import { PaymentConfirmationComponent } from '@pg-app/client/client-dashboard/components/send-payment-modal/containers/payment-confirmation/payment-confirmation.component';
import { ValidatePaymentComponent } from '@pg-app/client/client-dashboard/components/send-payment-modal/containers/validate-payment/validate-payment.component';
import { PaymentCompleteComponent } from '@pg-app/client/client-dashboard/components/send-payment-modal/containers/payment-complete/payment-complete.component';
import { CommonDialogModule } from '@pg-app/common/common-dialog-module.module';
import { SwiftCharacterMessageModule } from '@pg-app/shared/components/swift-character-message/swift-character-message.module';

@NgModule({
  imports: [
    CommonModule,
    CoreUiModule,
    CoreMaterialModule,
    NgbModule,
    ReactiveFormsModule,
    PipeModule,
    PinTwillioAuthyModule,
    CommonDialogModule,
    SwiftCharacterMessageModule
  ],
  declarations: [
    SendPaymentModalComponent,
    PaymentMandateComponent,
    PaymentInfomationComponent,
    BalanceTradeAvailableComponent,
    DrawdownSummaryComponent,
    PaymentConfirmationComponent,
    ValidatePaymentComponent,
    PaymentCompleteComponent
  ],
  entryComponents: [
    PaymentInfomationComponent
  ],
  exports: [
    PaymentMandateComponent,
    PaymentInfomationComponent,
    BalanceTradeAvailableComponent,
    DrawdownSummaryComponent,
    PaymentConfirmationComponent,
    ValidatePaymentComponent,
    PaymentCompleteComponent
  ]
})
export class SendPaymentModalModule { }
